import { Component, OnInit, ElementRef, ViewChild, Input, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { TitleConfigurations, TitleLineConfigurations } from '../title/title.configurations';
import { SingleDonutGraphConfigurations } from './single-donut-with-image-models';
import {KlaHttpService} from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { SingleDonutComponent } from 'app/shared/charts/single-donut/single-donut.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-single-donut-with-image',
  templateUrl: './single-donut-with-image.component.html',
  styleUrls: ['./single-donut-with-image.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, SingleDonutComponent, DynamicContentComponent ]
})
export class SingleDonutWithImageComponent implements OnInit {

  @ViewChild('panel', {static: true})
  public panel: ElementRef;

  @Input()
  public config: {
    image: string,
    imageObject: any,
    title: TitleConfigurations,
    chartId: string
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  public chartConfig: SingleDonutGraphConfigurations;

  public showChart = false;

  constructor(private http: KlaHttpService) {
    this.chartConfig = {
      id : '_' + Math.random().toString(36).substr(2, 9),
      width: 388,
      height: 368,
      thickness: 70,
      image: {},
      data: null
    };
  }

  ngOnInit() {
    this.chartConfig.image = this.config.imageObject;
    this.findChartData();
  }

  private findChartData() {
    this.http.getChartData('kla-single-donut', this.config.chartId).subscribe(
      (data) => {
        console.log('Single Donut API Response:', data);
        this.chartConfig.data = data;
        this.showChart = true;
        if (!this.chartConfig.data) {
          console.error('Please provide bar chart configurations');
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }
  private resize() {
    const rectangle = this.panel.nativeElement.getBoundingClientRect();
    if (rectangle.width < 607) {
      this.chartConfig.width = 387;
    }
    if (rectangle.width > 388) {
      this.chartConfig.width = 388;
    } else if (rectangle.width > 344 && rectangle.width < 388) {
      this.chartConfig.width = rectangle.width;
    } else if (rectangle.width < 345) {
      this.chartConfig.width = 345;
    }
  }
}
